
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/png-maker",
      function () {
        return require("private-next-pages/png-maker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/png-maker"])
      });
    }
  